import { render, staticRenderFns } from "./catalogue-list.vue?vue&type=template&id=2f248f80&scoped=true&"
import script from "./catalogue-list.vue?vue&type=script&lang=js&"
export * from "./catalogue-list.vue?vue&type=script&lang=js&"
import style0 from "./catalogue-list.vue?vue&type=style&index=0&id=2f248f80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f248f80",
  null
  
)

export default component.exports